import { ApiDataProcessorType } from '@highimpact-frontend/api-types';
import { api_dataprocessors } from '../../../api-commons';
import { IDataProcessorTypeService } from './IDataProcessorTypeService';

class DataProcessorTypeService implements IDataProcessorTypeService {
  async get(projectId: number, typeId: number): Promise<ApiDataProcessorType> {
    const { data } = await api_dataprocessors.get<ApiDataProcessorType>(
      `/projects/${projectId}/dataprocessor-types/${typeId}`
    );
    return data;
  }
  async getAll(projectId: number): Promise<ApiDataProcessorType[]> {
    const { data } = await api_dataprocessors.get<ApiDataProcessorType[]>(
      `/projects/${projectId}/dataprocessor-types`
    );
    return data;
  }
}

const DataProcessorTypeServiceInstance = new DataProcessorTypeService();

export default DataProcessorTypeServiceInstance;
